document.addEventListener('DOMContentLoaded', burger);
document.addEventListener('DOMContentLoaded', trick);
document.addEventListener('DOMContentLoaded', header);
function trick() {
    const lar = /large/i;
    const bl = /blanc/i;
    const nr = /noir/i;
    const vd = /^\-/;
    const mob = /only\-mobile/ ;
    const notmob = /not\-mobile/ ;
    let books = document.getElementsByTagName('figcaption');
    for ( let i = 0; i < books.length; i++) {
        let info = books[i].textContent;
        let img = books[i].parentNode;
        if (lar.test(info)) {
            img.classList.add('kg-width-wide');
        }
        if ( bl.test(info)) {
            img.classList.add('blanc');
        }
        if ( nr.test(info)){
            img.classList.add('noir');
        }

        if ( mob.test(info)){
            img.classList.add('mobi');
        }
        if ( notmob.test(info)){
            img.classList.add('notmob');
        }
    }
 let legs =  document.getElementsByClassName('kg-bookmark-description');
    for (let i=0; i < legs.length; i++) {
        let text = legs[i].textContent
        if (vd.test(text)){
           legs[i].classList.add('noleg');
        }
    }

 let titres = document.getElementsByClassName('kg-bookmark-title');
     for (let i=0; i < titres.length; i++) {
        let text = titres[i].textContent
        if (vd.test(text)){
           titres[i].classList.add('notitre');
        }
    }

};
function header() {
    let base =   window.pageYOffset;
    let flag = false;
    let top = true;
    let mvt = 0;
    document.addEventListener('scroll', function() {
        const elem = document.getElementById('headerID');
        const size = elem.clientHeight + 50;
        let pos =  window.pageYOffset;
        let de = pos;
        if (!flag) {
            window.requestAnimationFrame( function() {
                if (base > pos){
                    elem.style.top = "3vw";
                    top = true;
                    mvt = 0;
                }
                else if ( top && mvt < size) {
                    mvt = mvt + pos - base ;
                    elem.style.top = - mvt +'px';
                }
                else {
                    top = false
                    elem.style.top = - size +'px';
                }
                base = pos;
                flag = false;
            })
        }
        flag = true;
    })
}

function burger() {
    document.getElementById("burger").addEventListener("click", function() {
        document.getElementById("bod").classList.toggle("site-head-open");
    });
}
